import * as actionTypes from './ordersActionTypes';
import { dataService } from '../../Services/data-service';
import { toastr } from "react-redux-toastr";

export const setTabIndex = (tabIndex) => ({ type: actionTypes.SET_TAB_INDEX, tabIndex: tabIndex });
export const setTransportOrdersFetchActivated = (fetchActivated) => ({ type: actionTypes.SET_TRANSPORT_ORDERS_FETCH_ACTIVATED, fetchActivated: fetchActivated });

export const setActiveTransportOrders = () => dispatch => {

    return dataService.getActiveTransportOrdersWithDetails().then(orders => {
        toastr.removeByType('error');

        dispatch({ type: actionTypes.SET_ACTIVE_TRANSPORT_ORDERS, orders });
    },
        error => {
            toastr.error(`Error loading data: ${error.message}`);

        })
};

export const setCompletedTransportOrders = () => dispatch => {

    return dataService.getCompletedTransportOrdersWithDetails().then(orders => {
        toastr.removeByType('error');      

        dispatch({ type: actionTypes.SET_COMPLETED_TRANSPORT_ORDERS, orders });
    },
        error => {
            toastr.error(`Error loading data: ${error.message}`);

        })
};

export const setActiveTransportOrderExpandedRowIDs = (ids) => ({ type: actionTypes.SET_ACTIVE_TRANSPORT_ORDERS_EXPANDED_ROW_IDS, ids: ids });